import { createIcon } from '@chakra-ui/icons';

export const LocationPin = createIcon({
  displayName: 'LocationPin',
  viewBox: '0 0 15 14',
  path: [
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1963_18692)">
        <path
          d="M7.5 7.875C8.4665 7.875 9.25 7.0915 9.25 6.125C9.25 5.1585 8.4665 4.375 7.5 4.375C6.5335 4.375 5.75 5.1585 5.75 6.125C5.75 7.0915 6.5335 7.875 7.5 7.875Z"
          fill="currentColor"
        />
        <path
          d="M6.8875 13.7375C6.8 13.65 3.2125 10.5 3.2125 10.4125C1.9875 9.3625 1.375 7.7875 1.375 6.125C1.375 2.7125 4.0875 0 7.5 0C10.9125 0 13.625 2.7125 13.625 6.125C13.625 7.7875 13.0125 9.3625 11.7875 10.5C11.7 10.5875 8.2 13.7375 8.1125 13.825C7.7625 14.0875 7.2375 14.0875 6.8875 13.7375ZM4.525 9.3625L7.5 11.9875L10.475 9.3625C11.35 8.4875 11.875 7.4375 11.875 6.2125C11.875 3.7625 9.95 1.8375 7.5 1.8375C5.05 1.8375 3.125 3.675 3.125 6.125C3.125 7.35 3.65 8.4875 4.525 9.3625C4.525 9.275 4.525 9.275 4.525 9.3625Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1963_18692">
          <rect width="14" height="14" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
